import { BooleanInput, TextInput } from "react-admin";

import { DataKind } from "../../types";
import { CustomEdit, CustomUtcDateTimeInput } from "../custom";

function OtcMaintenanceWindowEdit() {
  return (
    <CustomEdit checkPermissionFor={DataKind.OtcMaintenanceWindow}>
      <TextInput
        label="Name"
        source="id"
        required
        style={{ display: "none" }}
        InputProps={{ readOnly: true }}
      />
      <CustomUtcDateTimeInput label="Start Time(UTC)" source="start_time" />
      <BooleanInput label="Completed" source="completed" />
    </CustomEdit>
  );
}

export default OtcMaintenanceWindowEdit;
